import { render } from "./ImportVideos.vue?vue&type=template&id=d7bdf5bc&scoped=true"
import script from "./ImportVideos.vue?vue&type=script&lang=ts"
export * from "./ImportVideos.vue?vue&type=script&lang=ts"

import "./ImportVideos.vue?vue&type=style&index=0&id=d7bdf5bc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d7bdf5bc"

export default script